import { render, staticRenderFns } from "./SelectTable.vue?vue&type=template&id=825a857e&"
import script from "./SelectTable.vue?vue&type=script&lang=js&"
export * from "./SelectTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports